import { render, staticRenderFns } from "./PorPlanoAbonos.vue?vue&type=template&id=5691abd6"
import script from "./PorPlanoAbonos.vue?vue&type=script&lang=js"
export * from "./PorPlanoAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports